"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitBacsResponsePagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var queryString = require("query-string");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var BacsResponseTable_1 = require("./BacsResponseTable");
var DirectDebitBacsResponsePagePlain = /** @class */ (function (_super) {
    __extends(DirectDebitBacsResponsePagePlain, _super);
    function DirectDebitBacsResponsePagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0;
        };
        _this.state = {
            loadingQueueSize: 0
        };
        return _this;
    }
    DirectDebitBacsResponsePagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.setState({ policyNumber: queryString.parse(_this.props.location.search).policy });
            _this.decrementLoadingQueueSize();
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getBacsResponsesByPolicyNumber(_this.props.params.number)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (bacsResponses) {
                _this.setState({ bacsResponses: bacsResponses });
            });
        });
    };
    DirectDebitBacsResponsePagePlain.prototype.render = function () {
        document.title = "BACS Response";
        if (this.templates.userHasRole(["Administrator", "CSR_Lead", "CSR", "Read_Only"])) {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.loading() }), this.templates.renderHeader(), this.templates.renderBackLink("Customer page", true, "/customers/".concat(this.props.params.id)), this.state.bacsResponses && (0, jsx_runtime_1.jsx)(BacsResponseTable_1.default, { bacsResponses: this.state.bacsResponses, customerReferenceNumber: this.props.params.id, loading: this.loading() })] }));
        }
        else {
            return this.templates.renderErrorPage();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DirectDebitBacsResponsePagePlain.prototype, "supportPortalService", void 0);
    DirectDebitBacsResponsePagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DirectDebitBacsResponsePagePlain);
    return DirectDebitBacsResponsePagePlain;
}(React.Component));
exports.DirectDebitBacsResponsePagePlain = DirectDebitBacsResponsePagePlain;
exports.default = (0, components_1.withRouter)(DirectDebitBacsResponsePagePlain);
//# sourceMappingURL=DirectDebitBacsResponsePage.js.map